import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core';

import { ContactTag, PropertiesTag, SystemTag } from '@ui/shared/model';
import { TranslatePipe } from '@ngx-translate/core';
import { ImmomioTooltipDirective, TooltipPosition } from '@immomio/ui/tooltip';
import { SlicePipe } from '@angular/common';
import {
  ImmomioDropdown,
  ImmomioDropdownTrigger,
  ImmomioDropdownMenu,
  ImmomioDropdownGroup
} from '@immomio/ui/dropdown';
import { TagComponent } from '../tag/tag.component';
import { BadgeComponent } from '../../atoms/badge/badge.component';
import { LabelListTagComponent } from './label-list-tag/label-list-tag.component';

@Component({
  selector: 'app-label-list',
  templateUrl: './label-list.component.html',
  styleUrls: ['./label-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ImmomioDropdown,
    ImmomioDropdownTrigger,
    ImmomioDropdownMenu,
    ImmomioDropdownGroup,
    LabelListTagComponent,
    BadgeComponent,
    ImmomioTooltipDirective,
    TagComponent,
    SlicePipe,
    TranslatePipe
  ]
})
export class LabelListComponent {
  readonly assignedTags =
    input<Array<ContactTag | PropertiesTag | SystemTag>>(undefined);
  readonly assignableTags =
    input<Array<ContactTag | PropertiesTag | SystemTag>>(undefined);
  readonly isSystemTag = input(false);
  readonly amountBeforeTruncation = input(2);
  readonly truncateLabels = input(true);
  readonly readonly = input(false);
  readonly multilineMode = input(false);
  readonly isAddLabelObject = input(false);
  readonly tooltipPlacement = input<TooltipPosition>('top');
  readonly assignTag = output<ContactTag | PropertiesTag | SystemTag>();
  readonly unassignTag = output<ContactTag | PropertiesTag | SystemTag>();

  public onAssignTag(tag: ContactTag | PropertiesTag | SystemTag): void {
    this.assignTag.emit(tag);
  }

  public onUnassignTag(tag: ContactTag | PropertiesTag | SystemTag): void {
    this.unassignTag.emit(tag);
  }
}
